<template>
  <div v-if="entries.length">
    <table>
      <thead>
      <tr>
        <th></th>
        <th>
          {{ $t('table.winnings') }}
        </th>
        <th>
          {{ $t('table.winners') }}
        </th>
        <th>
          {{ $t('table.date') }}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr
        v-for="(entry, index) in entries"
        :key="index"
      >
        <td>
          <component
            :is="entry.iconComponent"
          />
        </td>
        <td>
          <strong>
            {{ entry.amount }}
          </strong>
        </td>
        <td class="w-full text-left">
          {{ entry.postalCode }}
          <br class="sm:hidden">
          <span
            v-if="entry.name"
            class="winner-name"
          >
            {{ entry.name }}
          </span>
        </td>
        <td>
          {{ entry.date }}
        </td>
      </tr>
      </tbody>
    </table>
    <button
      class="btn btn--tertiary max-w-max mx-auto mt-4"
      :class="{'btn--loading': isLoading }"
      @click="nextPage"
      :disabled="disableNextPageButton"
    >
      {{ $t('table.btn-show-next') }}
    </button>
  </div>
</template>

<script setup lang="ts">
import DefaultIconsWinCoin from '~/components/Default/Icons/WinCoin.vue'
import DefaultIconsLoseCoin from '~/components/Default/Icons/LoseCoin.vue'
import type {PropType} from "vue";
import type GameDrawLocal from "~/libs/interfaces/GameDrawLocal";

const props = defineProps({
  items: {type: Array as PropType<GameDrawLocal[]>, required: true, default: []},
  isLoading: {type: Boolean, required: false, default: false},
  disableNextPageButton: {type: Boolean, required: false, default: true},
})

const emits = defineEmits(['nextPage'])

const currency = useCurrency()

const nextPage = () => {
  emits('nextPage')
}

const formatPsc = (psc?: string) => {
  if (!psc) {
    return psc
  }
  //return psc
  return `${psc?.substring(0, 3)} ${psc?.substring(3, 5)}`
}

const formatDate = (date?: Date) => {
  if (!date) {
    return date
  }
  return `${date.getDate()}. ${date.getMonth() + 1}. ${date.getFullYear()}`
}

const formatName = (name?: string) => {
  if (!name) {
    return name
  }
  // not need to format anything
  return name
}

const formatCurrency = (amount?: string | number) => {
  if (!amount) {
    return amount
  }
  return currency.toCurrency(amount)
}

const entries = computed(() => {
  return props.items?.map(draw => {
    const icon = draw.gameDrawWinner ? DefaultIconsWinCoin : DefaultIconsLoseCoin
    return {
      iconComponent: icon,
      amount: formatCurrency(Number(draw.prize || 0) + Number(draw.accumulatedPrize || 0)),
      postalCode: formatPsc(draw.winningPsc),
      name: formatName(draw.gameDrawWinner?.name),
      date: formatDate(draw.drawDatetime)
    }
  })
})
</script>

<style scoped lang="scss">
</style>
